module.exports = __webpack_public_path__ + "static/media/Introduce.6e2941b9.jpg";